export const COMPLIANCE_STATUS = {
  1: 'compliant',
  0: 'notCompliant',
  2: 'partiallyCompliant'
};

export const COMPLIANCE_STATUS_BY_TYPE = {
  COMPLIANT: 1,
  PARTIAL: 2,
  NOT_COMPLIANT: 0
};
